import styled from '@emotion/styled';

export const Description = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: ${(props) => props.theme.typography.colorSecondary};
`;
